export default "__VITE_ASSET__abaa30fe__"